import { Button, useRecordContext } from 'react-admin';

export const ViewDetailsButton = ({ onClick, ...props }) => {
    const record = useRecordContext(props);
    const handleClick = () => {
        onClick(record);
    };

    return <Button label="View details" onClick={handleClick} />;
};